export default "__VITE_ASSET__e0006b2d__"